<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
    layout: WebLayout,
}
</script>

<script setup>
import SEOHead from '@/components/SEOHead.vue'
</script>

<template>
    <SEOHead
        title="See you soon - Kulfood"
        description="During the summer period, Kulfood is temporarily adjusting the regular ordering offer via the website."
        keywords="Kulfood, obvestilo, naročanje, poletje"
        canonical="/obvestilo"
        image="/images/web/hero-bg.png"
        type="website"
    />

    <section class="relative isolate min-h-[680px] overflow-hidden bg-iron-grey">
        <img
            src="/images/web/hero-bg.png"
            alt="Fresh Kulfood meals"
            class="absolute inset-0 z-0 h-full w-full object-cover"
        >
        <div class="absolute inset-0 z-0 bg-gradient-to-r from-iron-grey via-iron-grey/82 to-iron-grey/35"></div>
        <div class="absolute inset-0 z-0 bg-black/28"></div>

        <div class="relative z-10 mx-auto flex min-h-[680px] max-w-6xl items-center px-4 py-20">
            <div class="max-w-3xl text-white">
                <div class="px-6 md:px-8">
                    <p class="mb-5 inline-flex rounded-full border border-white/30 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-linen backdrop-blur">
                        Obvestilo
                    </p>

                    <h1 class="old-standard-tt-regular mb-8 text-6xl uppercase leading-none tracking-wide text-white drop-shadow-lg md:text-7xl lg:text-8xl">
                        Kmalu ponovno z vami
                    </h1>
                </div>

                <div class="space-y-5 rounded-3xl border border-white/20 bg-white/12 p-6 text-lg leading-8 text-linen shadow-2xl shadow-black/20 backdrop-blur-md md:p-8">
                    <p class="font-semibold text-white">
                        Spoštovani,
                    </p>

                    <p>
                        v poletnem obdobju bomo redno ponudbo naročanja prek spletne strani začasno prilagodili. Ta čas bomo namenili pripravi novosti, optimizaciji naše storitve in razvoju še boljše uporabniške izkušnje, zato vsakodnevna dostava obrokov trenutno ne bo na voljo.
                    </p>

                    <p>
                        Še vedno sprejemamo naročila za 20 ali več obrokov po predhodnem dogovoru. Za naročilo nas pokličite na 
                        <a href="tel:+38640723726" class="font-semibold text-white underline decoration-red-rock decoration-2 underline-offset-4 hover:text-linen">
                            040/723-726
                        </a>.
                    </p>

                    <p>
                        Hvala za razumevanje in izkazano zaupanje. Veselimo se, da vas bomo kmalu ponovno razvajali z našimi svežimi obroki.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>
